"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeDifference = exports.utcNow = exports.hasFormSetValues = exports.getUniqueValues = exports.isEmptyString = exports.arrayToObject = exports.dictBy = exports.indexBy = exports.groupBy = exports.getDayjsTimeDiff = exports.renderPhoneNumber = exports.getTimeFromDayTimeId = exports.getDayTimeIdFromTime = exports.convertMinutesToDuration = exports.convertDurationToMinutes = exports.renderDuration = exports.renderDateTime = exports.renderDate = exports.DayTimeId = exports.DurationUnit = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["Minute"] = "min";
    DurationUnit["Hour"] = "h";
    DurationUnit["Day"] = "day(s)";
    DurationUnit["Week"] = "week(s)";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
const hoursInDay = 24;
const minutesInHour = 60;
const minutesInDay = 60 * 24;
const minutesInWeek = 60 * 24 * 7;
exports.DayTimeId = {
    AM: '791fc923-d7d7-4dca-b174-31fdd836c25e',
    PM: '916ce222-461d-42e9-92c3-0a5ad8b49cae',
};
// This function do exactly the same as 'renderDateTime', DO NOT USE IT!!
// We are keeping it due to legacy code.
function renderDate(date, format = 'MM/DD/YYYY') {
    if (!date)
        return '';
    return (0, dayjs_1.default)(date).format(format);
}
exports.renderDate = renderDate;
function renderDateTime(date, format = 'MM/DD/YYYY h:mmA') {
    if (!date)
        return '';
    return (0, dayjs_1.default)(date).format(format);
}
exports.renderDateTime = renderDateTime;
function renderDuration(value) {
    if (!value) {
        return '0 min';
    }
    if (value % minutesInWeek === 0) {
        return `${value / minutesInWeek} week(s)`;
    }
    if (value % minutesInDay === 0) {
        return `${value / minutesInDay} day(s)`;
    }
    if (value % minutesInHour === 0) {
        return `${value / minutesInHour} h`;
    }
    return `${value} min`;
}
exports.renderDuration = renderDuration;
function convertDurationToMinutes(value, unit) {
    if (unit === DurationUnit.Minute) {
        return value;
    }
    if (unit === DurationUnit.Hour) {
        return value * minutesInHour;
    }
    if (unit === DurationUnit.Day) {
        return value * minutesInDay;
    }
    if (unit === DurationUnit.Week) {
        return value * minutesInWeek;
    }
    return 0;
}
exports.convertDurationToMinutes = convertDurationToMinutes;
function convertMinutesToDuration(value) {
    if (!value) {
        return { value, unit: DurationUnit.Minute };
    }
    if (value % minutesInWeek === 0) {
        return { value: value / minutesInWeek, unit: DurationUnit.Week };
    }
    if (value % minutesInDay === 0) {
        return { value: value / minutesInDay, unit: DurationUnit.Day };
    }
    if (value % minutesInHour === 0) {
        return { value: value / minutesInHour, unit: DurationUnit.Hour };
    }
    return { value, unit: DurationUnit.Minute };
}
exports.convertMinutesToDuration = convertMinutesToDuration;
function getDayTimeIdFromTime(currentTime) {
    const hours = currentTime.get('hours');
    if (hours >= 12)
        return exports.DayTimeId.PM;
    return exports.DayTimeId.AM;
}
exports.getDayTimeIdFromTime = getDayTimeIdFromTime;
function getTimeFromDayTimeId(dayTimeId) {
    if (dayTimeId === exports.DayTimeId.PM)
        return [12, 'hour'];
    return [8, 'hour'];
}
exports.getTimeFromDayTimeId = getTimeFromDayTimeId;
function renderPhoneNumber(value, options) {
    if (!value)
        return '';
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;
    if (cvLength < 4)
        return currentValue;
    if (cvLength < 7)
        return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
    return (options === null || options === void 0 ? void 0 : options.useParenthesis)
        ? `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`
        : `${currentValue.slice(0, 3)}-${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
}
exports.renderPhoneNumber = renderPhoneNumber;
const ONE_SECOND = 1000;
const ONE_MIN = ONE_SECOND * 60;
const ONE_HOUR = ONE_MIN * 60;
const getDayjsTimeDiff = (startDate, endDate, time) => {
    const timeDiff = time !== null && time !== void 0 ? time : endDate === null || endDate === void 0 ? void 0 : endDate.diff(startDate);
    if (!timeDiff)
        return null;
    if (timeDiff < ONE_MIN)
        return `${Math.floor(timeDiff / ONE_SECOND)} s`;
    if (timeDiff < ONE_HOUR)
        return `${Math.floor(timeDiff / ONE_MIN)} m`;
    const hrs = Math.floor(timeDiff / ONE_HOUR);
    const mins = Math.floor((timeDiff - hrs * ONE_HOUR) / ONE_MIN).toString();
    const formattedMins = mins.length === 1 ? `0${mins}` : mins;
    return `${hrs}:${formattedMins} h`;
};
exports.getDayjsTimeDiff = getDayjsTimeDiff;
function groupBy(items, keySelector, valueSelector) {
    const result = new Map();
    items.forEach((item) => {
        const key = keySelector(item);
        const value = valueSelector(item);
        const resultItem = result.get(key);
        if (resultItem)
            resultItem.push(value);
        else
            result.set(key, [value]);
    });
    return result;
}
exports.groupBy = groupBy;
function indexBy(items, keySelector) {
    return new Map(items.map((x) => [keySelector(x), x]));
}
exports.indexBy = indexBy;
function dictBy(items, keySelector, valueSelector) {
    return new Map(items.map((x) => [keySelector(x), valueSelector(x)]));
}
exports.dictBy = dictBy;
function arrayToObject(arr, key) {
    return arr.reduce((obj, cur) => (Object.assign(Object.assign({}, obj), { [cur[key]]: cur })), {});
}
exports.arrayToObject = arrayToObject;
const isEmptyString = (value) => value === undefined || value === null;
exports.isEmptyString = isEmptyString;
const getUniqueValues = (data, values) => new Set(data.concat(values));
exports.getUniqueValues = getUniqueValues;
const hasFormSetValues = (formValues) => Object.values(formValues).some((formValue) => formValue !== undefined && formValue !== null && formValue instanceof Array && formValue.length > 0);
exports.hasFormSetValues = hasFormSetValues;
function utcNow() {
    return (0, dayjs_1.default)().toISOString();
}
exports.utcNow = utcNow;
const getTimeDifference = (dateTime, dateToDiff = utcNow()) => {
    const daysDiff = (0, dayjs_1.default)(dateToDiff).diff(dateTime, 'd');
    const hoursDiff = (0, dayjs_1.default)(dateToDiff).diff(dateTime, 'h');
    const minutesDiff = (0, dayjs_1.default)(dateToDiff).diff(dateTime, 'm');
    const days = daysDiff > 0 ? Number(daysDiff) : 0;
    const hours = hoursDiff > 23 ? hoursDiff - days * hoursInDay : hoursDiff;
    const minutes = minutesDiff > 59 ? minutesDiff - hoursDiff * minutesInHour : minutesDiff;
    const daysFormat = days === 1 ? `${days} day` : `${days} days`;
    const hoursFormat = hours < 10 ? `0${hours}` : hours;
    const minutesFormat = minutes < 10 ? `0${minutes}` : minutes;
    return `${daysFormat} ${hoursFormat}:${minutesFormat}`;
};
exports.getTimeDifference = getTimeDifference;
